module.exports = __webpack_public_path__ + "img/icon-earthy.7daa8f13.svg";